import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import {  AngularFireDatabase,AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PollListService {

  constructor(private db: AngularFireDatabase,private utilityService:UtilityService) { }

  getPollListData(eventId: string):Observable<any> {
    if(eventId != null) {
      let data :AngularFireObject<any> = this.db.object(Constants.EVENT_USER_DATA_URL+'/'+eventId+Constants.POLL_ANSWERS_URL);
      return  data.valueChanges();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/services/poll-list.service.ts